/**
 * InfoTooltip Component
 * 
 * Displays an info icon with instant tooltip on hover
 */

import React, { useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './InfoTooltip.css';

interface InfoTooltipProps {
  content: string;
  className?: string;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ content, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <span 
      className={`info-tooltip ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <InfoOutlinedIcon fontSize="small" />
      {isVisible && (
        <span className="info-tooltip-content">
          {content}
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
